import * as Perf from 'performance/Perf';
import {Filter, FilterKey} from 'search/SearchConstants';
import * as net from 'util/Net';

export interface ClientSearchConstants {
  filterKeysByItemType: {[itemType: string]: Array<string>};
  operatorsByFilterKey: {[filterKey: string]: Array<string>};
  operatorsByFieldType: {[fieldType: string]: Array<string>};
}

interface InferSearchParamsResponse {
  searchParams: {
    query: string;
    filters: Array<Filter>;
  } | null;
  error: string | null;
  traceId: string;
  filterErrors: Array<string> | null;
}

export async function inferSearchParams(
  userPrompt: string,
  availableTypes: Array<string>,
  availableFilterKeys: Array<FilterKey>,
  userTime: string,
  searchConstants: ClientSearchConstants
): Promise<InferSearchParamsResponse> {
  const perfId = Perf.start('llm.ai_search.user_latency_ms', {enabled: false}) ?? '';
  Perf.markStart(perfId);

  const inferredParamsResp = await net.postJSONPromise({
    url: '/1/api/search:infer-search-params',
    data: {userPrompt, availableTypes, availableFilterKeys, userTime, searchConstants},
  });

  Perf.markEnd(perfId);
  Perf.stop(perfId);

  return inferredParamsResp;
}
